import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import Accordion from 'react-bootstrap/Accordion'
import styled from 'styled-components'
import AnimationContainer from 'components/animation-container'

import { Helmet } from 'react-helmet';



class Hosting extends React.Component {

    shouldComponentUpdate() {
        return false
    }

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({ height: window.innerHeight })
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({ width: window.innerWidth })
        }
    }


    componentDidMount() {
        this.setState({ height: window.innerHeight, width: window.innerWidth })
        window.addEventListener('resize', this.updateDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }

    render() {

        // Datos estructurados para Faq
        const Faq =
        {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
                {
                    "@type": "Question",
                    "name": "¿Qué es un VPS no administrado en Colombia?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Un VPS no administrado en Colombia te da control total sobre tu servidor, ideal para desarrolladores en Bogotá o Pereira. Configura tu sistema operativo y aplicaciones sin restricciones, con soporte 24/7 disponible."
                    }
                },
                {
                    "@type": "Question",
                    "name": "¿Cómo funciona RAID 10 en un VPS?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "RAID 10 combina velocidad y redundancia, asegurando que tu VPS en Bogotá o Medellín sea rápido y seguro. Perfecto para aplicaciones críticas como e-commerce."
                    }
                },
                {
                    "@type": "Question",
                    "name": "¿Cuánto cuesta un VPS en Bogotá?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Nuestros VPS en Bogotá empiezan desde $90.000/mes, con RAID 10, SSD, y garantía de 30 días. Cotiza hoy para un plan personalizado."
                    }
                },
                {
                    "@type": "Question",
                    "name": "¿Por qué elegir un VPS en Pereira?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "En Pereira, ofrecemos VPS optimizados con baja latencia y soporte local 24/7, ideales para negocios en Risaralda que buscan rendimiento."
                    }
                },
                {
                    "@type": "Question",
                    "name": "¿Ofrecen soporte 24/7 en Cali y Medellín?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Sí, nuestro soporte 24/7 está disponible en Cali, Medellín, y toda Colombia. Resolvemos tus dudas en minutos, en español."
                    }
                }
            ]
        }

        const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #fff;
            padding: 80px 0 50px 0;
            .heading {
                width: 100%;            
            @media (max-width: 767px) {
                padding: 50px 0 50px 0;           
            }
            @media (min-width:768px) and (max-width:1500px) {
                padding: 50px 0 50px 0;              
            }
        `

        const ServiceRow = styled(Row)`
            margin-top: 10px;
        `
        const ServiceRow1 = styled(Row)`
            margin-top: 50px;
        `

        const TecText = styled.p`
            font-size: 18px;
            font-weight: 300;
            color: #4c4c4c;            
        `

        const Text = styled.p`
        font-size: 17px;
        font-family: "Open Sans", sans-serif;
        color: #777;        
        `
        const Color3 = styled.span`          
          color: #40a832;
          font-family: "Teko", sans-serif;            
        `

        const Heading2 = styled.h2`
            transform: translate(0, -100px);            
            transition: 1s;
            margin-top: 100px;            
            font-size: 70px;
            line-height: 70px;
            font-family: "Teko", sans-serif;
            font-weight: bold;
            color: #000;
            text-align: center;
            @media (max-width: 767px) {
                font-size: 50px;
                line-height: 50px;
            }
        `


        return (
            <Section id="faq">
                <Container>
                    {/* Llama al componente PreguntasRespuestas directamente */}
                    <Helmet>
                        <script type="application/ld+json">
                            {JSON.stringify(Faq)}
                        </script>
                    </Helmet>

                    <Heading2><Color3>Preguntas Frecuentes sobre</Color3> VPS en Colombia</Heading2>
                    <ServiceRow>
                        <Col md={12}>
                            <TecText>
                                Pero... ¿Qué es VPS? ¿Qué es RAID 10? ¿Qué es NO administrado?
                            </TecText>
                        </Col>
                    </ServiceRow>
                    <ServiceRow1>
                        <Col md={12}>
                            <AnimationContainer animation="fadeInDown" delay={500}>
                                <Accordion defaultActiveKey="0">
                                    {/* Item 0 */}
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>
                                            ¿Qué es un VPS no administrado en Colombia?
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Text>
                                                Un VPS no administrado en Colombia te da control total sobre tu servidor, ideal para desarrolladores en Bogotá o Pereira. Configura tu sistema
                                                operativo y aplicaciones sin restricciones, con soporte 24/7 disponible.
                                            </Text>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    {/* Item 1 */}
                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header>
                                            ¿Cómo funciona RAID 10 en un VPS?
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Text>
                                                “RAID 10 combina velocidad y redundancia, asegurando que tu VPS en Bogotá o Medellín sea rápido y seguro. Perfecto para aplicaciones críticas
                                                como e-commerce.
                                            </Text>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    {/* Item 2 */}
                                    <Accordion.Item eventKey="2">
                                        <Accordion.Header>
                                            ¿Cuánto cuesta un VPS en Bogotá?
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Text>
                                                Nuestros VPS en Bogotá empiezan desde un precio muy económico al mes, con RAID 10, SSD, y garantía de 30 días. Cotiza hoy para un plan personalizado.
                                            </Text>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    {/* Item 3 */}
                                    <Accordion.Item eventKey="3">
                                        <Accordion.Header>
                                            ¿Por qué elegir un VPS en Pereira?
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Text>
                                                En Pereira, ofrecemos VPS optimizados con baja latencia y soporte local 24/7, ideales para negocios en Risaralda y todo el Eje Cafetero que buscan
                                                rendimiento.
                                            </Text>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    {/* Item 4 */}
                                    <Accordion.Item eventKey="4">
                                        <Accordion.Header>
                                            ¿Ofrecen soporte 24/7 en Cali y Medellín?
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Text>
                                                Sí, nuestro soporte 24/7 está disponible en Cali, Medellín, y toda Colombia. Resolvemos tus dudas en minutos, en español.
                                            </Text>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    {/* Item 5 */}
                                    <Accordion.Item eventKey="5">
                                        <Accordion.Header>
                                            ¿Cuánto cuesta el hosting en Colombia?
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Text>
                                                Los precios para un hosting en Colombia son relativamente bajos y van desde los $79.997 pesos colombianos.
                                            </Text>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    {/* Item 6 */}
                                    <Accordion.Item eventKey="6">
                                        <Accordion.Header>
                                            ¿Cómo elegir el VPS adecuado para mi sitio web de WordPress?
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Text>
                                                Un VPS es una opción ideal cuando tu sitio web de WordPress ya no puede funcionar de manera eficiente en un alojamiento compartido. Te brinda mayor control,
                                                mejor rendimiento y más seguridad. Además, los VPS te permiten instalar herramientas personalizadas y optimizar tu sitio para satisfacer tus necesidades exactas,
                                                algo que no siempre es posible en un alojamiento compartido. Si estás buscando un VPS especializado para WordPress, nuestros planes están optimizados para
                                                ofrecer el mejor rendimiento y soporte 24/7. ¡Ponte en contacto con nosotros para obtener más detalles sobre la opción perfecta para tu sitio web de WordPress!
                                            </Text>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    {/* Item 7 */}
                                    <Accordion.Item eventKey="7">
                                        <Accordion.Header>
                                            ¿Qué diferencia a un VPS gestionado de un VPS no gestionado?
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Text>
                                                En un VPS gestionado, el proveedor de alojamiento se encarga de la mayoría de las tareas técnicas relacionadas con la administración del servidor. Esto incluye la
                                                instalación y configuración del sistema operativo, actualizaciones regulares, copias de seguridad automáticas, monitoreo constante de seguridad y soporte técnico
                                                especializado. Esto es ideal para empresas o personas que no tienen experiencia técnica o prefieren centrarse en sus negocios en lugar de gestionar la
                                                infraestructura del servidor.
                                            </Text>
                                            <Text>
                                                Un VPS no gestionado ofrece más control total sobre la administración del servidor, lo que significa que serás responsable de la instalación, mantenimiento,
                                                actualizaciones y seguridad del servidor. Este tipo de VPS es ideal para usuarios con experiencia técnica que necesitan una flexibilidad total y desean gestionar
                                                el servidor de acuerdo con sus necesidades exactas.
                                            </Text>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </AnimationContainer>
                        </Col>
                    </ServiceRow1>
                </Container>
            </Section>
        )
    }

}

export default Hosting